/**
 * @generated SignedSource<<6fea97e3e80105f96c523d7a5f25082f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleTopicWidgetArticle$data = {
  readonly entityId: string;
  readonly firstTopic: {
    readonly contents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId: string;
          readonly " $fragmentSpreads": FragmentRefs<"articleWidgetContent">;
        };
      }>;
    } | null | undefined;
    readonly disableFollow: boolean | null | undefined;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "followButtonBase">;
  } | null | undefined;
  readonly sponsorType: string | null | undefined;
  readonly " $fragmentType": "articleTopicWidgetArticle";
};
export type articleTopicWidgetArticle$key = {
  readonly " $data"?: articleTopicWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleTopicWidgetArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleTopicWidgetArticle",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sponsorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "firstTopic",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "followButtonBase"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disableFollow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 4
            },
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": {
                "direction": "DESC",
                "field": "PUBLISHED_DATE"
              }
            }
          ],
          "concreteType": "ContentConnection",
          "kind": "LinkedField",
          "name": "contents",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "articleWidgetContent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "contents(first:4,orderBy:{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"})"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "c5db2294fa8c7dd45abd0f6bcfac21eb";

export default node;
